import React, { useState } from "react";
import { Form } from "antd";
import "./style.scss";
import Input from "components/BaseWidgets/form/input";
import Select from "components/BaseWidgets/select";
import Button from "components/BaseWidgets/button";
import SuccessModal from "../components/successModal/index ";
import { useNavigate } from "react-router-dom";
import { useSelectOptions } from "hooks/api/useListing";
import { useAccountFor } from "hooks/api/useAuth";

function AccountFor({ name, profileFor }) {
  const [openModal, setOpenModal] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const { mutate: accountFor, isPending } = useAccountFor({
    onSuccess: () => {
      setOpenModal(true);
    },
  });

  const { profileCreatedFor, gender } = useSelectOptions();

  const onFinish = (value) => {
    const formField = {
      gender: value.gender,
      profile_for: value.profileFor,
      name: value.name,
    };
    accountFor(formField);
  };

  return (
    <>
      <div className="page-heading">
        <h1 className="title font-title-xl mb-2">Who’s this account for?</h1>
        <p className="subtitle font-body-xs">
          Confirm your entered details to continue.
        </p>
      </div>
      <div className="auth-form-container">
        <Form
          form={form}
          className="account-form login-form"
          onFinish={onFinish}
          layout="vertical"
          initialValues={{ name, profileFor }}
        >
          <Form.Item
            name="profileFor"
            className="form-item m-0"
            rules={[
              {
                required: true,
                message: "Please select who this profile is for",
              },
            ]}
          >
            <Select
              widthVariant="wFull"
              labelClassName={`label`}
              inputClassName={`select-dropdown`}
              label="The profile is for..."
              options={profileCreatedFor?.options}
              isLoading={profileCreatedFor?.isLoading}
            />
          </Form.Item>

          <Form.Item
            name="name"
            className="custom-error "
            rules={[{ required: true, message: "Please enter your name" }]}
          >
            <Input id="name" labelClass={`label`} label="Name" placeholder="" />
          </Form.Item>

          <Form.Item
            name="gender"
            className="form-item m-0"
            rules={[
              {
                required: true,
                message: "Please select who this profile is for",
              },
            ]}
          >
            <Select
              widthVariant="wFull"
              labelClassName={`label`}
              inputClassName={`select-dropdown`}
              label="Gender"
              options={gender?.options}
              showSearch={false}
              isLoading={gender?.isLoading}
            />
          </Form.Item>

          <Button isLoading={isPending} htmlType="submit" wFull>
            Continue
          </Button>
        </Form>
      </div>
      <SuccessModal
        open={openModal}
        onCancel={() => {
          setOpenModal(false);
          navigate("/onboard#1", { replace: true });
        }}
        onOk={() => {
          setOpenModal(false);
          navigate("/onboard#1", { replace: true });
        }}
        title="Congratulations, you are now registered."
        description="Now, let's complete your profile."
      />
    </>
  );
}

export default AccountFor;
